// extracted by mini-css-extract-plugin
module.exports = {"bottomSheet":"cookie-consent-CookieConsent-bottomSheet-ed404f50"};